import { render } from "./Clientes.vue?vue&type=template&id=abcdbb24&scoped=true"
import script from "./Clientes.vue?vue&type=script&lang=js"
export * from "./Clientes.vue?vue&type=script&lang=js"

import "./Clientes.vue?vue&type=style&index=0&id=abcdbb24&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abcdbb24"]])

export default __exports__